import type { Enums } from '@/integrations/supabase/types';

export type BodyTypeEnum = Enums<'body_type'>;

export interface BodyTypeGroup {
  key: string;
  label: string;
  members: BodyTypeEnum[];
}

/**
 * Karrosseri-grupper som de vises i UI. Flere DB-enum-værdier kan
 * mappes til samme gruppe (fx "Station Wagon" + "Stationscar").
 */
export const bodyTypeGroups: BodyTypeGroup[] = [
  { key: 'suv', label: 'SUV', members: ['SUV', 'Crossover'] },
  { key: 'stationcar', label: 'Stationcar', members: ['Station Wagon', 'Stationscar'] },
  { key: 'hatchback', label: 'Hatchback', members: ['Hatchback', 'Minibil'] },
  { key: 'sedan', label: 'Sedan', members: ['Sedan', 'Fastback'] },
  { key: 'mpv', label: 'MPV', members: ['MPV'] },
  { key: 'coupe', label: 'Coupé', members: ['Coupe'] },
  { key: 'convertible', label: 'Cabriolet', members: ['Convertible'] },
  { key: 'van', label: 'Van', members: ['Van'] },
  { key: 'pickup', label: 'Pickup', members: ['Pickup'] },
  { key: 'other', label: 'Andet', members: ['Other'] },
];

const enumToGroup = new Map<BodyTypeEnum, BodyTypeGroup>();
bodyTypeGroups.forEach((g) => g.members.forEach((m) => enumToGroup.set(m, g)));

export function getBodyTypeGroup(value: BodyTypeEnum): BodyTypeGroup | undefined {
  return enumToGroup.get(value);
}

export function expandBodyTypeGroup(key: string): BodyTypeEnum[] {
  return bodyTypeGroups.find((g) => g.key === key)?.members ?? [];
}

/**
 * Slår en valgt enum-værdi op og returnerer alle enum-værdier fra
 * samme gruppe (inkl. selve værdien). Bruges fx hvis HomeFilters har
 * gemt en enkelt enum i URL'en og Cars-siden skal ekspandere.
 */
export function expandEnumToGroup(value: BodyTypeEnum): BodyTypeEnum[] {
  return getBodyTypeGroup(value)?.members ?? [value];
}

/**
 * Givet en liste valgte enum-værdier, returnerer hvilke gruppe-keys
 * der er aktive (en gruppe er aktiv hvis mindst én af dens members er valgt).
 */
export function getActiveGroupKeys(selected: string[]): Set<string> {
  const set = new Set<string>();
  selected.forEach((v) => {
    const g = enumToGroup.get(v as BodyTypeEnum);
    if (g) set.add(g.key);
  });
  return set;
}
